import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { ProgressSpinner } from 'primereact/progressspinner';
import useGetDataUser from '../../../CustomHooks/useGetDataUser';
import { formateoBasico } from '../../../utilities/formateos';
import './ModalCrearNota.scss';
import { getNotas, registrarNota, revisarNota } from './TablaBitacorasntegracion';

const ModalCrearNota = ({ data, setShowCrearNota, visible }) => {
    const dataUser = useGetDataUser();
    const [nota, setNota] = useState('');
    const [notas, setNotas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingNotas, setLoadingNotas] = useState(true);

    useEffect(() => {
        if (data && data.id_bitacora) {
            cargarNotas();
        }
    }, [data]);

    const cargarNotas = async () => {
        setLoadingNotas(true);
        await getNotas(data.id_bitacora).then((response) => {
            setNotas(response);
        })
            .catch((error) => {
                console.error('Error al obtener notas:', error);
                setNotas([]);
            });
        setLoadingNotas(false);
    };

    const handleGuardarNota = async () => {
        if (!nota.trim()) {
            alert('Por favor ingrese una nota');
            return;
        }
        console.log("dataUser", dataUser);

        setLoading(true);
        try {
            const nuevaNota = {
                id_bitacora: data.id_bitacora,
                nota: nota,
                id_usuario: dataUser?.ID,
            };

            await registrarNota(nuevaNota).then((response) => {
                console.log('Nota registrada:', response);
            })
                .catch((error) => {
                    console.error('Error al registrar nota:', error);
                    alert('Error al guardar la nota');
                });

            // Limpiar el campo de nota después de guardar
            setNota('');
            // Recargar las notas para mostrar la nueva
            await getNotas(data.id_bitacora).then((response) => {
                setNotas(response);
            })
                .catch((error) => {
                    console.error('Error al obtener notas:', error);
                    setNotas([]);
                });

        } catch (error) {
            console.error('Error al guardar nota:', error);
            alert('Error al guardar la nota');
        } finally {
            setLoading(false);
        }
    };

    const handleRevisadoChange = async (idNota, revisado) => {
        try {
            // TODO: Reemplazar con tu endpoint real
            await revisarNota(idNota, revisado, dataUser?.ID).then((response) => {
                console.log('Revisado actualizado:', response);
            })
                .catch((error) => {
                    console.error('Error al actualizar revisado:', error);
                });

            setNotas(notas.map(n =>
                n.ID === idNota ? { ...n, REVISADO: revisado } : n
            ));
        } catch (error) {
            console.error('Error al actualizar revisado:', error);
        }
    };

    const footer = (
        <div className="modal-footer-buttons">
            <Button
                label="Cerrar"
                icon="pi pi-times"
                onClick={() => setShowCrearNota(false)}
                className="p-button-secondary"
            />
        </div>
    );

    return (
        <Dialog
            header="Notas de Bitácora"
            visible={visible}
            className="modalDialog modal-notas"
            onHide={() => setShowCrearNota(false)}
            footer={footer}
        >
            <div className="modal-crear-nota">
                <div className="info-bitacora">
                    <p><strong>Bitácora ID:</strong> {data.id_bitacora}</p>
                </div>

                <div className="nueva-nota-section">
                    <label htmlFor="nueva-nota" className="titleN">Nueva Nota</label>
                    <InputTextarea
                        id="nueva-nota"
                        value={nota}
                        onChange={(e) => setNota(e.target.value)}
                        rows={4}
                        placeholder="Escribe tu nota aquí..."
                        className="w-full"
                        disabled={loading}
                        autoResize
                    />
                    <Button
                        label={loading ? "Guardando..." : "Guardar Nota"}
                        icon={loading ? "pi pi-spin pi-spinner" : "pi pi-save"}
                        onClick={handleGuardarNota}
                        className="p-button-success"
                        disabled={loading || !nota.trim()}
                        style={{ marginTop: '10px', width: '100%' }}
                    />
                </div>

                <div className="notas-lista-section">
                    <h3 className="titleN">Notas Registradas</h3>
                    {loadingNotas ? (
                        <div className="loading-container">
                            <ProgressSpinner style={{ width: '50px', height: '50px' }} />
                        </div>
                    ) : notas.length === 0 ? (
                        <p className="no-notas">No hay notas registradas</p>
                    ) : (
                        <div className="notas-escalera">
                            {notas.map((notaItem, index) => (
                                <div
                                    key={notaItem.ID || index}
                                    className={`nota-card ${notaItem.REVISADO ? 'revisada' : ''}`}
                                >
                                    <div className="nota-header">
                                        <span className="nota-fecha">
                                            <i className="pi pi-calendar" />
                                            {notaItem.FECHA}
                                        </span>
                                        <span className="nota-usuario">
                                            <i className="pi pi-user" />
                                            Registrado por : {notaItem?.NOMBRE_USUARIO_REGISTRO}
                                        </span>
                                    </div>
                                    <div className="nota-contenido">
                                        <p>{notaItem.NOTA}</p>
                                    </div>
                                    <div className="nota-footer">
                                        <div className="nota-revisado">
                                            <Checkbox
                                                inputId={`revisado-${notaItem.ID}`}
                                                checked={notaItem.REVISADO}
                                                onChange={(e) => handleRevisadoChange(notaItem.ID, e.checked)}
                                            />
                                            <label htmlFor={`revisado-${notaItem.ID}`}>
                                                Revisado
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </Dialog>
    );
};

export default ModalCrearNota;
